/*
 * Widget types.
 */

export enum WidgetTypesEnum {
  BLOCK = 'BLOCK',
  LAYER = 'LAYER',
}

/*
 * Template.
 */

export interface WidgetTemplate {
  id: string;
  type: WidgetTypesEnum;
}

/*
 * Widget.
 */

export interface Widget {
  id: string;
  type: WidgetTypesEnum;
  window: Window;
}
